import { Expose } from "class-transformer";
import { IsDefined, IsString } from "class-validator";

export class TopThree {
  @Expose()
  @IsDefined()
  @IsString()
  first!: string;

  @Expose()
  @IsDefined()
  @IsString()
  second!: string;

  @Expose()
  @IsDefined()
  @IsString()
  third!: string;
}
